module.exports = __webpack_public_path__ + "54cf98f5/img/send-icon.3cfb6275.svg";